/**
 * Query keys for the tres-commas endpoints (/api/tres-commas/*). Own root,
 * so nothing here can share a cache entry with a Voluum or Binom query.
 * For Media Devoted | Created By Ciro Autiero
 */

export const tresCommasKeys = {
  all: ['tres-commas'] as const,
  campaigns: () => [...tresCommasKeys.all, 'campaigns'] as const,
  campaign: (id: string) => [...tresCommasKeys.campaigns(), id] as const,
  campaignFlows: (id: string) => [...tresCommasKeys.campaign(id), 'flows'] as const,
  flows: () => [...tresCommasKeys.all, 'flows'] as const,
  flow: (id: string) => [...tresCommasKeys.flows(), id] as const,
  dashboardToday: (from?: string, to?: string) =>
    [...tresCommasKeys.all, 'dashboard-today', from ?? '', to ?? ''] as const,
};
